import React from 'react';
import './BuyProgressModal.css';
import './Loader.css';

const BuyProgressModal = ({ isOpen, steps, mensajesPasos, requestId, txid, onClose }) => {
  if (!isOpen) {
    return null;
  }

  const allStepsCompleted = steps.every((p) => p.completado);
  const currentStepIndex = steps.findIndex((p) => !p.completado);

  const ScaledLoader = ({ className = '' }) => (
    <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{ transform: 'scale(0.2)' }}>
            <div className={`loader ${className}`}>
                <span></span>
            </div>
        </div>
    </div>
  );

  return (
    <div className="modal-overlay">
      <div className="buy-progress-modal-card">
        <h2>Buy progress</h2>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '20px' }}>
          {/* Left side: Step list */}
          <div style={{ flex: '0 1 50%' }}>
            <ul className="progress-steps">
              {steps.map((paso, idx) => (
                <li
                  key={idx}
                  className={`step ${paso.completado ? "completed" : ""}`}>
                  <div className="step-icon">
                    {paso.completado
                      ? <ScaledLoader className="green" />
                      : (idx === currentStepIndex ? <ScaledLoader /> : idx + 1)
                    }
                  </div>
                  <div>
                    <span className="step-text">{paso.label}</span>
                    {paso.completado && (
                      <div className="step-message">{mensajesPasos[idx]}</div>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Right side: Big loader */}
          {!allStepsCompleted && (
            <div style={{ flex: '0 1 50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{ transform: 'scale(0.7)' }}>
                <div className="loader">
                  <span></span>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Request ID and Button below */}
        {requestId && (
          <div className="mensaje-txid card" style={{ marginTop: '20px' }}>
            <strong>Request ID:</strong>
            <span style={{ wordBreak: "break-all" }}>{requestId}</span>
          </div>
        )}

        {txid && (
          <div className="mensaje-txid card" style={{ marginTop: '20px' }}>
            <strong>Transaction ID:</strong>
            <a 
              href={`https://blockstream.info/testnet/tx/${txid}`} 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ wordBreak: "break-all" }}
            >
              {txid}
            </a>
          </div>
        )}

        {allStepsCompleted && (
          <button
            className="btn-action"
            style={{ marginTop: "24px" }}
            onClick={onClose}
          >
            Swap Again
          </button>
        )}
      </div>
    </div>
  );
};

export default BuyProgressModal;